import { render } from "./PersonDetailDialog.vue?vue&type=template&id=43380547&scoped=true&ts=true"
import script from "./PersonDetailDialog.vue?vue&type=script&lang=ts"
export * from "./PersonDetailDialog.vue?vue&type=script&lang=ts"

import "./PersonDetailDialog.vue?vue&type=style&index=0&id=43380547&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43380547"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
